<template>
  <v-container fluid class="contract-work-orders" v-if="contract">
    <v-row class="flex-grow-0">
      <v-btn text
             x-small
             color="primary"
             exact
             :to="{name: 'contract-list'}">
        &lt;&lt; {{ $t('app_drawer.contract') }}
      </v-btn>
    </v-row>

    <v-row class="contract-info-wrapper">
      <v-col cols="12">
        <div class="contract-info">
          <h3>[{{ contract.id }}] {{ contract.name }}</h3>
        </div>
      </v-col>
      <v-col cols="12">
        <span class="contract-finalised-div">
          {{ contract.finalised_at ? $t('contract.finalised') : $t('contract.not_finalised') }}
          <v-icon color="#5BC23F"
                  small
                  v-if="contract.finalised_at">mdi-check</v-icon>
        </span>
      </v-col>

      <v-col cols="12" class="breadcrumbs">
        <v-btn-toggle>
          <v-btn outlined
                 text
                 :to="{name: 'contract-detail', params: {contractId: $route.params.contractId}}">Info
          </v-btn>
          <v-btn color="primary">Work Order
          </v-btn>
        </v-btn-toggle>
      </v-col>

      <v-col cols="12">
        <v-btn color="primary"
               class="mr-2"
               small
               @click="createWorkOrder(false)">
          <v-icon>mdi-plus</v-icon>
          Adjustment
        </v-btn>
        <v-btn color="primary"
               class="mr-2"
               small
               @click="createWorkOrder(true)">
          <v-icon>mdi-plus</v-icon>
          Estimate
        </v-btn>
        <v-btn color="primary"
               class="mr-2"
               small
               :disabled="selectedWorkOrderIds.length === 0"
               @click="transferWorkOrders">
          <v-icon>mdi-swap-horizontal</v-icon>
          Transfer
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="flex-grow-1">
      <v-col>
        <ContractWorkOrderList full-height
                               :refresh-trigger.sync="refreshTrigger"
                               :contract-id="$route.params.contractId"
                               show-select
                               v-model="selectedWorkOrderIds"></ContractWorkOrderList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {onMounted, ref} from "@vue/composition-api/dist/vue-composition-api";
import {ACTION_TYPES} from "@/store/types";
import ContractWorkOrderList from "@/components/contract/ContractWorkOrderList";
import CreateWorkOrderDialog from "@/components/contract/CreateWorkOrderDialog";
import {computed} from "@vue/composition-api";
import _ from "lodash";
import {PERMISSIONS} from "@/constants";
import SelectAccountDialog from "@/components/SelectAccountDialog.vue";

export default {
  name: 'ContractWorkOrders',
  components: {ContractWorkOrderList},
  setup(props, {root}) {
    const contract = ref(null);
    const getContract = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/contract/',
        params: {contract_id: root.$route.params.contractId},
      });

      if (response.body.success) {
        contract.value = response.body.contract;
      }
    }
    const canManageContract = computed(() => {
      if (contract.value) {
        return _.some([PERMISSIONS.MANAGE_CONTRACT], (p) => root.$store.getters.hasPermission(p))
          || contract.value.created_by.id === root.$store.getters.account.id;
      }

      return false;
    })
    const refreshTrigger = ref(false);
    const selectedWorkOrderIds = ref([]);

    const createWorkOrder = async function (isEstimate) {
      const workOrderId = await root.$dialog.showAndWait(CreateWorkOrderDialog, {
        contractId: root.$route.params.contractId,
        isEstimate,
        showClose: false,
        persistent: true,
        width: '720px',
      });

      if (workOrderId) {
        root.$router.push({name: 'work-order-detail', params: {workOrderId}});
      }
    }
    const transferWorkOrders = async function () {
      const account = await root.$dialog.showAndWait(SelectAccountDialog, {
        title: root.$t('work_order.transfer_title'),
        showClose: false,
        persistent: true,
        width: '640px',
      });

      if (account && await root.$dialog.confirm({text: root.$t('work_order.transfer_confirm_msg')})) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: 'admin/contract/work_order/set_admin/',
          params: {
            work_order_ids: selectedWorkOrderIds.value,
            account_id: account.id,
          },
        })

        if (response.body.success) {
          selectedWorkOrderIds.value = [];
          refreshTrigger.value = true;
        }
      }
    }


    onMounted(() => {
      getContract();
    })

    return {
      contract,
      canManageContract,
      refreshTrigger,
      selectedWorkOrderIds,

      createWorkOrder,
      transferWorkOrders,
    }
  },
}
</script>

<style lang="less">
.contract-work-orders {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .contract-info-wrapper {
    flex: 0 0 auto;
    display: flex;

    .contract-info {
      flex: 1 1 0;
    }

    .contract-info-btns {
      flex: 0 0 auto;
      width: 200px;
    }
  }

  .contract-disable-row {
    flex: 0 0 auto;
    background-color: rgba(238, 119, 122, 0.1);
  }

  .contract-detail-row {
    flex: 0 0 auto;
    background-color: #FFFFFF;

    &.finalised {
      background-color: #FFFFFF88;
    }
  }

  .contract-finalised-div {
    border-radius: 12px;
    padding: 2px 8px;
    border: solid 1px #6C757D;
    color: #6C757D;
    background-color: rgba(108, 117, 125, 0.1);

    &.finalised {
      border: solid 1px #5BC23F;
      color: #5BC23F;
      background-color: rgba(91, 194, 63, 0.2);
    }
  }
}
</style>
